import { useState } from 'react';

const useFormInput = (inputValue) => {
  const [value, setValue] = useState(inputValue);

  const handleChange = (e) => setValue(e.target.value);

  return {
    value,
    onChange: handleChange,
  };
};

export default useFormInput;